import { CONTENT_PLAYING, CLEAR_PLAYING_CONTENT } from 'player/actions';
import {
    ANALYTICS_READY,
    CLOSE_MODAL_MESSAGE,
    CONTENT_SELECT,
    CONTENT_UNSELECT,
    DISPLAY_MODAL_MESSAGE,
    FETCH_EXTERNAL_CONFIG,
    FETCH_EMBEDDED_OPTIONS,
    INIT_APP_DATA,
    MEDIA_QUERY
} from '../actions/appActions';

export default function appReducer(state = {
    isMobile: false,
    selectedContent: {},
    playingContent: {}
}, action) {
    switch (action.type) {
        case ANALYTICS_READY:
            return { ...state, analytics: action.initData };
        case CLEAR_PLAYING_CONTENT:
            return { ...state, playingContent: {} };
        case CLOSE_MODAL_MESSAGE:
            return {
                ...state,
                showModalMessage: false,
                messageType: '',
                messageData: null,
                lastMessageType: state.messageType,
                lastMessageData: state.messageData
            };
        case CONTENT_SELECT:
            return { ...state, selectedContent: action.content };
        case CONTENT_UNSELECT:
            return { ...state, selectedContent: {} };
        case CONTENT_PLAYING:
            return { ...state, playingContent: action.content };
        case DISPLAY_MODAL_MESSAGE:
            return { ...state, showModalMessage: true, messageType: action.messageType, messageData: action.messageData };
        case FETCH_EXTERNAL_CONFIG:
            return { ...state, bootstrap: action.bootstrap };
        case FETCH_EMBEDDED_OPTIONS:
            return { ...state, options: action.options };
        case INIT_APP_DATA:
            return {
                ...state,
                country: action.country,
                device: action.device,
                env: action.env,
                isMobile: action.isMobile,
                lang: action.lang,
                location: action.location,
                locale: action.locale,
                messages: action.messages
            };
        case MEDIA_QUERY:
            return { ...state, mq: action.mq };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./app/common/reducers/appReducer.js